<template>
  <div>
    <form-wizard
      ref="formWizard"
      :title="null"
      :subtitle="null"
      class="bg-white mb-1"
      step-size="xs"
      shape="circle"
      @on-complete="formSubmitted"
      @on-loading="setLoading"
    >
      <template #next>
        <b-button
          variant="primary"
        >
          Proximo
        </b-button>
      </template>

      <template #prev>
        <b-button
          variant="primary"
        >
          Voltar
        </b-button>
      </template>

      <template #finish>
        <b-button
          variant="primary"
        >
          {{ formIntegration.inteSelected.id != null ? 'Atualizar Integração' : 'Salvar Integração' }}
        </b-button>
      </template>
      <!-- Escolher o chat fluxo que vai ser monitorado -->
      <tab-content
        title="Para leads gerados nos fluxos"
        :before-change="validateAsync"
      >
        <b-row v-if="!loadingWizard">
          <b-col
            cols="12"
            class="mb-2"
          >
            <b-form-group>
              <v-select
                v-model="formIntegration.chatSelected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :reduce="chat => chat"
                :options="chatsExistents"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- Configuração dos campos a ser mapeado do chat (@cpf pessoa) -->
      <tab-content
        title="Configurações"
        :before-change="validateAsync"
      >
        <b-col
          cols="12"
          class="mb-2 px-0"
        >
          <h5 class="mb-0">
            <b>Informações do contato</b>
          </h5>
          <small class="text-muted">Dados obrigatórios para a criação de um contato</small>
        </b-col>
        <b-row v-if="!loadingWizard">
          <b-col
            v-for="(form, index) in formIntegration.formActivicampaignConfig"
            :key="index"
            cols="12"
            class="mb-2"
          >
            <b-form-group>
              <div>
                <strong
                  v-if="form.id !== 'email'"
                  class="mb-5"
                >{{ form.title }}</strong>
                <strong
                  v-else
                  class="mb-5"
                >{{ form.title }} <span style="color: red">*</span></strong>
              </div>

              <Info
                v-if="form.title !== ''"
                :id="`form_rd_${form.id}`"
                :message="form.value"
                :variaveis="variaveis"
                :is-tag-value="false"
                @atualizarMessage="atualizarValue($event, form)"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            class="mb-2"
          >

            <div class="form-group">
              <label for="pipedrive">Tag:</label>
              <select
                id="pipedrive"
                v-model="selected"
                class="form-control"
              >
                <option>Selecione</option>
                <option
                  v-for="tag in options"
                  :key="tag.value"
                  :value="tag.value"
                >
                  {{ tag.text }}
                </option>
              </select>
            </div>
          </b-col>
        </b-row>
      </tab-content>
      <div
        v-if="loadingWizard"
        class="loader"
      />
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import Info from '@/views/App/Chat/Info.vue'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from 'bootstrap-vue'
import { ActiveCampaignService } from '@/services/ActiveCampaign'
import { useApi } from '@/composables/useApi'

const activeCampaignService = new ActiveCampaignService()
const apiBack = useApi()
export default {
  components: {
    FormWizard,
    TabContent,
    BFormSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    Info,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      chatsExistents: [],
      variaveis: [],
      isValid: true,
      loadingWizard: false,
      selected: null,
      options: [],

    }
  },
  computed: {
    formIntegration: {
      get() {
        return this.$store.getters['AppChatbooster/GET_CURRENT_INTEGRATION']
      },
      set(newValue) {
        this.$store.commit('AppChatbooster/SET_CURRENT_INTEGRATION_ACTIVE', newValue)
      },
    },
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    isFormValid: {
      get() {
        return this.formIntegration.formActivicampaignConfig.find(item => item.id === 'email').value === ''
      },
      set(value) {
        this.formIntegration.formActivicampaignConfig.find(item => item.id === 'email').value = value
      },
    },
  },
  async mounted() {
    if (this.formIntegration.inteSelected.id != null) {
      this.setTag()
    }
    this.setLoading(true)
    await this.getAllChats()
    this.setLoading(false)
    this.getTags()
  },

  methods: {
    setTag() {
      this.selected = this.$store.getters['AppChatbooster/GET_CURRENT_INTEGRATION']
        .formActivicampaignConfig
        .find(item => item.id === 'id_tag').value
    },
    atualizarValue(value, form) {
      this.formIntegration.formActivicampaignConfig.map(f => {
        if (f.id === form.id) {
          f.value = value.replace(/<[^>]*>/g, '')
        }
        return f
      })
    },
    resetFormIntegration() {
      this.$store.commit('AppChatbooster/RESET_INTEGRATION', {
        chatSelected: '',
        formActivicampaignConfig: [
          { title: 'Nome do contato', id: 'firstName', value: '' },
          { title: 'Sobrenome', id: 'lastName', value: '' },
          { title: 'Email do contato', id: 'email', value: '' },
          { title: 'Telefone', id: 'phone', value: '' },
        ],
        inteSelected: {
          id: null,
        },
      })
      this.$store.commit('AppChatbooster/SET_CURRENT_TAB_INTEGRATION', 'integrations')
    },
    validateAsync() {
      return new Promise((resolve, reject) => {
        if (this.$refs.formWizard.activeTabIndex === 0 && this.formIntegration.chatSelected === '') {
          this.$refs.formWizard.activeTabIndex = 0
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Chat não pode ser vazio',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          document.querySelector('.tinymce-heading-fluxo_form_rd_chat').focus()
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(false)
          return false
        }
        if (this.$refs.formWizard.activeTabIndex === 1 && this.formIntegration.formActivicampaignConfig.find(item => item.id === 'email').value === '') {
          this.$refs.formWizard.activeTabIndex = 1
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'E-mail não pode ser vazio',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          document.querySelector('.tinymce-heading-fluxo_form_rd_email').focus()
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(false)
          return false
        }
        this.setLoading(true)
        this.getAllVariaveis().then(() => {
          this.setLoading(false)
          resolve(true)
        })
        resolve(true)
        return true
      })
    },
    setLoading(value) {
      this.loadingWizard = value
    },
    changeTab() {
      console.log('changeTab')
    },
    async getAllChats() {
      await apiBack.get(`/chat/${this.getUserData.id}`)
        .then(data => {
          this.chatsExistents = data.data
        })
        .catch(err => console.error(err))
    },
    async formSubmitted() {
      document.querySelectorAll('.gatilho-selected').forEach(item => {
        item.classList.remove('gatilho-selected')
      })

      if (this.formIntegration.inteSelected.id != null) {
        this.formIntegration.formActivicampaignConfig.map(item => {
          if (item.id === 'id_tag') {
            item.value = this.selected
          }
          return item
        })
        await apiBack.put(`/Integracoes/${this.formIntegration.inteSelected.id}`, {
          modelo: 'Activecampaign',
          fluxos: this.formIntegration.chatSelected.name,
          eventos: 'lead::finish',
          id_user: this.getUserData.id,
          id_chat: this.formIntegration.chatSelected.id,
          modelo_metadata: JSON.stringify(this.formIntegration.formActivicampaignConfig),
          url: '',
        })
          .then(() => {
            this.$message({
              type: 'success',
              message: 'Atualizado com sucesso',
            })
          })
          .catch(err => console.error(err))

        this.$refs.formWizard.reset()
        this.resetFormIntegration()
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Integração criada com sucesso!',
            icon: 'EditIcon',
            variant: 'success',
          },

        })
        this.formIntegration.formActivicampaignConfig.push({
          title: '',
          id: 'id_tag',
          value: this.selected,
        })
        const formData = {
          modelo: 'Activecampaign',
          fluxos: this.formIntegration.chatSelected.name,
          eventos: 'lead:finish',
          id_user: this.getUserData.id,
          id_chat: this.formIntegration.chatSelected.id,
          modelo_metadata: JSON.stringify(this.formIntegration.formActivicampaignConfig),
          id_tag_activi: this.selected,
        }
        this.$store.dispatch('AppChatbooster/SAVE_INTEGRATION_DB', formData)
        this.$refs.formWizard.reset()
        this.resetFormIntegration()
      }
    },
    async getAllVariaveis() {
      await apiBack.post('/getAllVariaveisByArray', {
        array: [this.formIntegration.chatSelected.id],
      })
        .then(data => {
          this.variaveis = JSON.parse(JSON.stringify(data.data))
        })
        .catch(err => console.error(err))
    },
    async getTags() {
      await activeCampaignService.tagActiveCampaign(this.getUserData.id)
        .then(resp => {
          this.options = resp
        })
    },
    changeTagSelected(e) {
      this.formIntegration.formActivicampaignConfig.map(f => {
        if (f.id === 'id_tag') {
          f.value = e
        }
        return f
      })
    },
  },
}
</script>

<style scoped lang="scss">
.gatilho-selected {
  border: 2px solid red;
  background: #ff000017;
}

/* This is a css loader. It's not related to vue-form-wizard */
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #e74c3c;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>
